var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12C10.37 12 11.19 11.74 11.88 11.3L14.32 13.74L15.74 12.32L13.3 9.89C13.7329 9.21111 13.9748 8.42814 14.0004 7.6234C14.026 6.81867 13.8343 6.0219 13.4455 5.31688C13.0566 4.61186 12.485 4.02462 11.7907 3.61692C11.0964 3.20922 10.3051 2.99611 9.5 3C7 3 5 5 5 7.5C5 10 7 12 9.5 12ZM9.5 5C10.163 5 10.7989 5.26339 11.2678 5.73223C11.7366 6.20107 12 6.83696 12 7.5C12 8.16304 11.7366 8.79893 11.2678 9.26777C10.7989 9.73661 10.163 10 9.5 10C8.83696 10 8.20107 9.73661 7.73223 9.26777C7.26339 8.79893 7 8.16304 7 7.5C7 6.83696 7.26339 6.20107 7.73223 5.73223C8.20107 5.26339 8.83696 5 9.5 5ZM18 0H2C0.9 0 0 0.9 0 2V14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM18 14H2V2H18V14Z",
    fill: "#A0A7B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.660e18067e79b6d4c9e1fbfdef3fb08f.svg";
export { ForwardRef as ReactComponent };